<template>
	<div class="area-info">
		<span>{{text}}</span>
	</div>
</template>
<script type="text/ecmascript-6">
	import {getOrgArea} from '@/api/organization'
	export default {
		name: 'LyAreaInfo',
		props: {
			id: {
				type: String,
				default: ''
			}
		},
		data () {
			return {
				text: ''
			}
		},
		methods: {
			getInfo () {
				getOrgArea({id: this.id}).then(response =>{
					let data = response.data;
					let provinceName = data.provinceName?data.provinceName:'';
					let cityName = data.cityName?data.cityName:'';
					let countyName = data.countyName?data.countyName:'';
					this.text = provinceName+' '+cityName+' '+countyName;
				})
			}
		},
		created() {
			this.getInfo();
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/area-info/index.vue